import styled from 'styled-components'

export const TimeLineWrapper = styled.div`
  .timeline {
    margin: 20px 0;
    position: relative;

    .timeline__step {
      position: relative;
      height: 2px;
      background: ${props => props.theme.colors.iron};
      float: left;
      margin-bottom: 60px;

      &.done {
        text-decoration: line-through;
        border-top: 2px solid ${props => props.theme.colors.primary};

        .timeline__step-marker {
          background: ${props => props.theme.colors.primary};
          border: 2px solid ${props => props.theme.colors.primary};
        }
        .timeline__step-title {
          text-decoration: line-through;
        }
      }

      &.active {
        border-top: 2px solid ${props => props.theme.colors.primary};

        .timeline__step-title {
          color: ${props => props.theme.colors.primary};
        }
        .timeline__step-marker {
          border: 2px solid ${props => props.theme.colors.primary};
        }
      }

      &:first-child {
        .timeline__step-marker {
          transform: translate(100%, -50%);
        }
        .timeline__step-title {
          transform: translateX(100%);
        }
      }

      &:last-child {
        .timeline__step-marker {
          transform: translate(0, -50%);
        }
        .timeline__step-title {
          transform: translateX(0);
        }
      }

      .timeline__step-title {
        position: absolute;
        color: ${props => props.theme.colors.regentGray};
        top: 15px;
        right: 0;
        transform: translateX(50%);
      }

      .timeline__step-marker {
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);
        width: 18px;
        height: 18px;
        background: ${props => props.theme.colors.white};
        border: 2px solid ${props => props.theme.colors.iron};
        border-radius: 50%;
        z-index: 1;
      }
    }
  }
`
